export default __webpack_public_path__ + "static/media/mapa.73948584.png";